export default "__VITE_ASSET__BtW5nsEt__"